import { render } from "./AccountManagementForm.vue?vue&type=template&id=6f383d80"
import script from "./AccountManagementForm.vue?vue&type=script&lang=js"
export * from "./AccountManagementForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__